export default import.meta.ROLLUP_FILE_URL_q6tfGKm3Qmt5DJmATeHQdA;